module.exports = __webpack_public_path__ + "static/media/contactless_entry.d5ac0414.svg";